<div *ngIf="isLoggedIn">

    <div *ngIf="currentRoute!='/cart/account' && currentRoute!='/cart/checkout' && currentRoute!='/cart/payment'">

        <!-- DESKTOP NAVBAR -->
        <section class="desktop-navbar">
            <div class="logo-bar position-relative">
                <div class="container-fluid">
                    <div class="row new-mobile-setting">
                        <div class="col-5 col-md-4 col-xl-3 logo-res">
                            <a href="javascript:void(0)" (click)="logoRedirection()" class="logoimag">
                                <img [src]="logoPath" class="img-fluid header-logo" alt="logo" />
                            </a>
                        </div>

                        <nav
                            class=" navbar navbar-expand-md navbar-light justify-content-center p-md-0 mr-md-auto">
                            <button class="navbar-toggler" type="button" data-toggle="collapse"
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                aria-expanded="false" aria-label="Toggle navigation"  aria-haspopup="true">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                                <div class="navbar-nav"> 
                                    <ul class="list-inline text-center d-flex mb-0 create-gap">
                                        <!-- <li class="list-inline-item" *ngIf="isLoggedIn">
                                            <a routerLink="/my-account" routerLinkActive="active-link">Dashboard</a>
                                        </li> -->
                                        <div class="list-inline ">
                                            <!-- <li class="list-inline-item dropdown" (mouseover)="openDropdown()"
                                                (mouseout)="closeDropdown()">
                                                <a class="dropdown-toggle cp">Products</a>
                                                <div class="dropdown-menu" [ngClass]="{ 'show': isDropdownOpen }">
                                                    <a class="dropdown-item" routerLink="/wheels">Wheels</a>
                                                    <a class="dropdown-item" routerLink="/accessories">Accessories</a>
                                                </div>
                                            </li> -->
                                            <li class="list-inline-item dropdown">
                                                <a class="cp" routerLink="/wheels">Products</a>
                                            </li>
                                        </div>

                                        <!-- <li class="list-inline-item">
                                            <a routerLink="/wheels" routerLinkActive="active-link">Products</a>
                                        </li> -->
                                        <!-- <li class="list-inline-item">
                                            <a routerLink="/wheelbrand" routerLinkActive="active-link">Brands</a>
                                        </li> -->
                                        <!-- <li class="list-inline-item">
                                            <a routerLink="/pre-order-deals" routerLinkActive="active-link">Pre Order Deals</a>
                                        </li> -->
                                        <li class="list-inline-item" *ngIf="isLoggedIn">
                                            <a routerLink="/suppliers" routerLinkActive="active-link">Suppliers</a>
                                        </li>
                                        <!-- <li class="list-inline-item" *ngIf="isLoggedIn">
                                            <a routerLink="/downloads" routerLinkActive="active-link">Downloads</a>
                                        </li>
                                        <li class="list-inline-item" *ngIf="isLoggedIn && helperService.isSubscribed(profileData, 'premium-plan')">
                                            <a routerLink="/my-account/integration" routerLinkActive="active-link">Integrations</a>
                                        </li>
                                        <li class="list-inline-item" *ngIf="isLoggedIn">
                                            <a routerLink="/my-account/my-invoices" routerLinkActive="active-link">My Invoices</a>
                                        </li> -->
                                    </ul>
                                </div>
                            </div>
                        </nav>


                        

                        

                        <div
                            class="col-4 col-md-3 col-xl-3    incld-btnhvr d-flex align-items-center justify-content-end">
                            <a routerLink="/login" *ngIf="!isLoggedIn">
                                <!-- Log In -->
                                <i class="fa fa-sign-in" aria-hidden="true" style="font-size:31px"></i>
                            </a>

                            <!-- <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
                                <a routerLink="/my-account" *ngIf="isLoggedIn">
                                    My Account
                                </a>
                                <div ngbDropdownMenu aria-labelledby="dropdownManual">
                                    <a href="javascript:void(0)" ngbDropdownItem (click)="logout()">Sign Out</a>
                                </div>
                            </div> -->

                            <div class="dropdown">
                                <a *ngIf="isLoggedIn" class="dropdown-toggle" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fa fa-user"></i>
                                    <span class="account-text">My Account</span>
                                </a>
                                <div class="dropdown-menu cart-menu" aria-labelledby="dropdownMenuButton">
                                    <a routerLink="/my-account/my-profile" class="text-center py-3">
                                        Account Dashboard
                                    </a>
                                    <!-- Security: Only show Price Setting for premium plan users -->
                                    <ul class="dropdown-sub-price-menu" 
                                        *ngIf="helperService.canHideCostPrice(profileData)"
                                        aria-labelledby="navbarDropdownMenuLinkRight">
                                        <li class="pricetoggler">
                                            <a routerLink="/my-account" class="justify-content-center price-menu py-2">
                                                Price Setting
                                            </a>
                                            <ul class="dropdown-submenu dropdown-submenu-left">
                                                <li>
                                                    <a class="dropdown-item py-2">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio"
                                                                name="flexRadioDefault" id="flexRadioDefault1"
                                                                [checked]="is_hide_cost == 1">
                                                            <label class="form-check-label" style="cursor: pointer;"
                                                                for="flexRadioDefault1"
                                                                (click)="toggleCostSetting($event, 'click', 0)">
                                                                Hide Cost
                                                            </label>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item py-2">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio"
                                                                name="flexRadioDefault" id="flexRadioDefault2"
                                                                [checked]="is_hide_cost == 0">
                                                            <label class="form-check-label" style="cursor: pointer;"
                                                                for="flexRadioDefault2"
                                                                (click)="toggleCostSetting($event, 'click', 1)">
                                                                Show Cost
                                                            </label>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                    <a href="javascript:void(0)" class="text-danger justify-content-center py-3"
                                        ngbDropdownItem (click)="logout()">Logout</a>
                                </div>
                            </div>

                            <a routerLink="/cart" class="cart-icon">
                                <i class="fa fa-shopping-cart icon"></i>
                                <small class="cart-count" *ngIf="cartCount > 0">{{ cartCount }}</small>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="navbar-section">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-6 col-md-6 col-lg-3">
                            <button class="w-100 h-100 br-25 bg-white text-black" data-toggle="modal"
                                data-target="#searchbyvehicle">Search by Vehicle</button>
                        </div>
                        <div class="col-sm-6 col-md-6 col-lg-3">
                            <button class="w-100 h-100 br-25 bg-white text-black" data-toggle="modal"
                                data-target="#searchbysize">Search by Size</button>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-6">
                            <form class="search-form" id="" action="">
                                <div class="header-search d-flex">
                                    <input type="text" #searchElement class="form-control" (keyup)="onSearch($event)"
                                        value="{{searcKeyWord}}" placeholder="Search by brand, model, part number..."
                                        aria-describedby="basic-addon2">
                                    <button class="btn btn-search" type="button" (click)="showNewResultTemplate()">
                                        <img src="/assets/img/black-search-icon.svg" />
                                    </button>
                                </div>
                            </form>
                        </div>

                        
                    </div>
                </div>
            </div>


        </section>
    </div>

    <!-- new search form -->
    <div class="srch-bx" [style.display]="newSearcTem">
        <button class="srch-cross res-btn d-md-none d-lg-none d-xl-none  d-sm-block d-xs-block"></button>
        <div class="search-bar">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-sm-10 col-md-9 no-pad">
                        <input autocomplete="off" #searchElement (keyup)="onSearch($event)" value="{{searcKeyWord}}"
                            placeholder="Search" type="search">
                    </div>
                    <div class="col-12 col-sm-2 col-md-3 no-pad bg">
                        <button _ngcontent-uxj-c8="" class="btn btn-02 f-larg" type="button"
                            (click)="clearSearchWord()"> Clear</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="opac-layer"></div>

        <div class="w-100 float-left" *ngIf="searchResult">
            <div class="yra-aftr-srch w-100 float-left" *ngIf="searchResult.products">
                <h3>Products</h3>
                <div class="yra-aftr-srch-prdt-hd w-100 float-left">
                    <ng-template ngFor [ngForOf]="searchResult.products.slice(0, 15)" let-product>
                        <div class="yra-aftr-srch-prdt">
                            <div class="latest-bx">
                                <a (click)="hideSearchBar(product.searchable.slug, product.searchable.sku)">
                                    <div class="latest-bx-tp"
                                        [ngStyle]="{'background-image': 'url('+ imagePath.transform(baseImage.transform(product.searchable.images)) +')'}">
                                    </div>
                                </a>
                                <div class="latest-bx-mid">
                                    <h4>
                                        <a (click)="hideSearchBar(product.searchable.slug, product.searchable.sku)">
                                            <span class="scr-sku">{{ product.searchable.sku }}</span>
                                            <span class="scr-name"> {{ product.searchable.name }}</span>
                                            <span class="scr-bp-o"> {{ product.searchable.bolt_pattern }}, {{
                                                product.searchable.offset }}</span>
                                        </a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div class="yra-aftr-srch w-100 float-left"
                *ngIf="searchResult.products?.length > 15 || searchResult.brands?.length > 15">
                <div class="see-all-srch-prdt">
                    <button class="btn btn-02 f-large" (click)="goSearchPage()">See All</button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- header for cart -->
<div class="for-border pb-3 pt-3"
    *ngIf="currentRoute=='/cart/account' || currentRoute=='/cart/checkout' || currentRoute=='/cart/payment'">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-md-9 col-xl-9 col-sm-7 logo-mobil">
                <a href="javascript:void(0)" (click)="logoRedirection()" class="cart-logo-anchor">
                    <img [src]="logoPath" class="img-fluid cart-logo" alt="img" />
                </a>
            </div>
            <div class="col-md-3 col-xl-3 col-sm-5">
                <div class="checkout-head-text">
                    <p class="mb-0 mt-3 mt-sm-0 text-left text-sm-right">Secure Checkout</p>
                </div>
            </div>
        </div>
    </div>
</div>
















<div class="landingheader"
    *ngIf="!isLoggedIn && currentRoute!='/login' && currentRoute!='/vendor-login' && currentRoute!='/reset-password'">
    <div class="upper-header">
        <div class="container">
            <div class="row">
                <div class="col-md-12 justify-content-between">
                    <div class="">
                        <a routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">For
                            Retailers</a>
                        <a routerLink="/feature" routerLinkActive="active-link"
                            [routerLinkActiveOptions]="{ exact: true }">For Suppliers</a>
                    </div>
                    
                        <div class="">
                            <a *ngIf="!isLoggedIn && !isFeatureRoute()" routerLink="/login" class="header-retailer-btn retailer-btn d-block d-md-none">Retailer Login</a>
                        <a *ngIf="isFeatureRoute()" href="https://admin.theclockwork.app" class="header-retailer-btn retailer-btn d-block d-md-none"
                    target="_blank">Supplier Login</a>
                        </div>
                </div>
            </div>
        </div>
    </div>
    <nav class="navbar navbar-expand-md navbar-light bg-light">
        <div class="container">
            <a class="navbar-brand" routerLink="/">
                <img [src]="logoPath" />
            </a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
                aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarText">
                <ul class="navbar-nav ml-auto mb-lg-0">

                    <li class="nav-item">
                        <a class="nav-link" *ngIf="!isFeatureRoute()" href="/#featureretailer">Features</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" *ngIf="isFeatureRoute()" href="/feature#supplierfeature">Features</a>
                    </li>
                    <li class="nav-item">
                        <a *ngIf="!isFeatureRoute()" class="nav-link" href="#pricing">Pricing</a>
                    </li>
                </ul>
            </div>
            <div class="landing-btns d-none d-md-block">
                <a *ngIf="!isLoggedIn && !isFeatureRoute()" routerLink="/login" class="retailer-btn ">Retailer Login</a>
                <a *ngIf="isFeatureRoute()" href="https://admin.theclockwork.app" class="retailer-btn"
                    target="_blank">Supplier Login</a>
            </div>
        </div>
    </nav>
</div>

<div *ngIf="isLoggedIn">
    <div class="modal fade filter-modal" id="searchbyvehicle" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <app-search-by-vehicle></app-search-by-vehicle>
    </div>


    <div class="modal fade filter-modal" id="searchbysize" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <app-search-by-size></app-search-by-size>
    </div>
</div>